import type { FC } from 'react'

import { Image } from '@skytech/ui/Image'

import { numberFormat } from '@/util/formatters/numbers'

import type { DeviceApplicationProduct as DeviceApplicationProductType } from './types'

import './DeviceApplicationProduct.styles.scss'

const DeviceApplicationProduct: FC<{
  product: DeviceApplicationProductType
  isLeasing?: boolean
}> = ({ product, isLeasing = false }) => (
  <div className="device-application-product">
    <div className="device-application-product__thumbnail">
      {product.imgUrl ? <Image src={product.imgUrl} alt={product.model} /> : undefined}
    </div>

    <div className="device-application-product__text">
      <p className="device-application-product__text__model">{product.model}</p>

      <p className="device-application-product__text__price">
        {numberFormat(isLeasing ? product.leasingPrice : product.price)},-
      </p>
    </div>
  </div>
)

export default DeviceApplicationProduct
